import React from 'react';
import Header from '../../components/Header';
import Faq from './Faq';
import Contact from './Contact';
import Hero from './Hero';
import Slogan from './Slogan';
import Footer from '../../components/Footer';
import TrackView from '../../components/Onetrack/TrackView';
import Url from './Url';
const getQueryString = (name:string) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
  }

const Home = () => {
  const query = getQueryString('locale')
  console.log(query);
  
return(
  <TrackView tip="71.1.0.1.2145">
      <div>
        <Header />
        <Hero />
        <Slogan />
        <Faq />
        {query==='en' ? (<Url />) : null}
        <Contact />
        <Footer />
      </div>
    </TrackView>
)
    
};

export default Home;
